<template
  ><section class="candidate-page">
    <header class="candidate-heading">
      <button class="control-link" @click="$router.back()">返回</button>
      <h2>常用场景配置</h2>
      <button
        class="control-link candidate-complete"
        :disabled="!candidateContentReady || loadingCandidates || savingCandidates"
        @click="configReturnBtnHandle"
      >
        完成
      </button>
    </header>
    <candidate-toolbar
      :selected-count="selectedCount"
      placeholder="搜索区域或场景名称"
      :keyword="inputKeyword"
      :region-options="regionOptions"
      :category-options="[]"
      :region-id="selectedRegionId"
      @input="candidateKeywordChange"
      @search="submitCandidateSearch"
      @clear="clearCandidateSearch"
      @region="regionFilterChange"
    />
    <div ref="content" class="candidate-content" @scroll.passive="onScroll">
      <div class="control-grid scene-grid">
        <scene-item-view
          v-for="item in serveSceneList"
          :key="candidateKey(item)"
          :OneScene="item"
          viewType="configScene"
          :disabled="savingCandidates"
          @followOrderCompuder="followOrderCompuder"
          @followOrderCompuInc="followOrderCompuInc"
        />
      </div>
      <p v-if="candidateContentReady && !serveSceneList.length" class="control-empty">
        没有符合条件的场景
      </p>
      <div class="paging-footer">
        {{ candidateFooterText
        }}<button
          v-if="!loadingCandidates && hasMoreCandidates"
          class="control-link"
          @click="loadMoreCandidates"
        >
          加载更多
        </button>
      </div>
    </div>
  </section></template
>
<script>
import { request, lightRequest } from '@/network/request'
import router1 from '@/router'
import { changefollowOrder, changefollowOrderInc } from '@/common/tool'
import {
  ensureRegionNavigationScope,
  requestNextRegionNavigationPage
} from '@/common/region-navigation-data'
import SceneItemView from './scene-view/scene-item-view'
import CandidateToolbar from './follow-candidate-toolbar'
const getControlViewportWidth = () => Math.min(1200, window.innerWidth)
const showTipsToast = (vm, ...args) => vm.$showTipsToast(...args)
export default {
  data() {
    return {
      controlViewportWidth: getControlViewportWidth(),
      allCandidateList: [],
      queryRecordList: [],
      inputKeyword: '',
      appliedKeyword: '',
      selectedRegionId: '',
      candidatePageNo: 0,
      candidatePageSize: 30,
      candidateTotal: 0,
      candidateHasMore: true,
      candidateAutoFillBlocked: false,
      candidatePagingUsed: false,
      loadingCandidates: false,
      savingCandidates: false,
      candidateResetLoading: false,
      candidateContentReady: false,
      selectionDirty: false,
      pendingCandidateRefresh: false,
      candidateRequestGeneration: 0,
      searchKeyboardActive: false,
      serveSceneList: [],
      SenceflexLastFlexEle: []
    }
  },

  computed: {
    regionOptions() {
      const source = this.$store.state.regionnavigation.regionList || []
      return [
        {
          id: '',
          name: '全部区域'
        }
      ].concat(
        source
          .filter(item => item && item.regionId)
          .map(item => ({
            id: item.regionId,
            name: item.regionName
          }))
      )
    },

    selectedCount() {
      return this.allCandidateList.filter(item => item && item.followState === 1).length
    },

    hasMoreCandidates() {
      return this.candidateHasMore
    },

    candidateFooterText() {
      if (this.loadingCandidates) return '正在加载...'
      if (this.candidatePagingUsed && !this.hasMoreCandidates) return '已加载全部'
      return ''
    }
  },
  methods: {
    candidateKey(item) {
      return String((item && item.sceneId) || '')
    },

    mergeCandidateItems(items) {
      const map = {}
      this.allCandidateList.forEach(item => {
        map[this.candidateKey(item)] = item
      })
      ;(items || []).forEach(item => {
        const key = this.candidateKey(item)

        if (map[key]) {
          const state = map[key].followState
          const order = map[key].followOrder
          Object.assign(map[key], item)

          if (this.selectionDirty) {
            map[key].followState = state
            map[key].followOrder = order
          }
        } else {
          map[key] = item
          this.allCandidateList.push(item)
        }
      })
      return (items || []).map(item => map[this.candidateKey(item)] || item)
    },

    loadModernCandidates(reset, requestGeneration) {
      let loadedSuccessfully = false
      if (this.loadingCandidates) {
        if (reset) this.pendingCandidateRefresh = true
        return Promise.resolve()
      }

      if (!reset && !this.hasMoreCandidates) return Promise.resolve()
      const generation =
        requestGeneration == null ? this.candidateRequestGeneration : requestGeneration
      const pageNo = reset ? 1 : this.candidatePageNo + 1
      this.loadingCandidates = true
      this.candidateResetLoading = reset === true
      return lightRequest({
        method: 'post',
        url: '/home/findFollowScenePage',
        data: {
          token: this.$store.state.token,
          keyword: this.appliedKeyword,
          regionId: this.selectedRegionId,
          page: {
            pageNo: pageNo,
            pageSize: this.candidatePageSize
          }
        }
      })
        .then(res => {
          if (generation !== this.candidateRequestGeneration) return
          if (!res.data || res.data.code != 0)
            throw res.data || {
              message: '获取场景失败'
            }
          const data = res.data.data || {}
          if (reset && !this.selectionDirty) this.allCandidateList = []
          this.mergeCandidateItems(data.selectedItems || [])
          const records = this.mergeCandidateItems(data.records || [])
          const previousCount = reset ? 0 : this.queryRecordList.length
          this.queryRecordList = reset
            ? records
            : this.queryRecordList.concat(
                records.filter(
                  item =>
                    !this.queryRecordList.some(
                      old => this.candidateKey(old) === this.candidateKey(item)
                    )
                )
              )
          this.candidateAutoFillBlocked = this.queryRecordList.length <= previousCount
          this.refreshCandidateDisplayOrder()

          if (reset) {
            this.candidateContentReady = true
          }

          this.candidatePageNo = pageNo
          const responseTotal = Number(res.data.page && res.data.page.totalNo)
          this.candidateTotal =
            Number.isFinite(responseTotal) && responseTotal >= 0
              ? responseTotal
              : this.queryRecordList.length
          this.candidateHasMore =
            records.length > 0 && pageNo * this.candidatePageSize < this.candidateTotal
          if (pageNo > 1) this.candidatePagingUsed = true
          loadedSuccessfully = true
        })
        .catch(error => {
          if (generation === this.candidateRequestGeneration) {
            showTipsToast(this, 3, error.message || '获取场景失败', true, 3000)
          }
        })
        .finally(() => {
          this.loadingCandidates = false
          this.candidateResetLoading = false

          if (this.pendingCandidateRefresh) {
            this.pendingCandidateRefresh = false
            this.loadModernCandidates(true, this.candidateRequestGeneration)
          } else if (loadedSuccessfully && generation === this.candidateRequestGeneration) {
            this.showFlexComputer()
          }
        })
    },

    refreshCandidates() {
      this.candidatePagingUsed = false
      this.candidateRequestGeneration += 1
      return this.loadModernCandidates(true, this.candidateRequestGeneration)
    },

    loadMoreCandidates() {
      if (!this.hasMoreCandidates) return
      this.loadModernCandidates(false)
    },

    candidateKeywordChange(value) {
      this.inputKeyword = value || ''
    },

    submitCandidateSearch(options) {
      const keyword = String(this.inputKeyword || '').trim()
      if ((!options || options.force !== true) && keyword === this.appliedKeyword) return
      this.appliedKeyword = keyword
      this.refreshCandidates()
    },

    clearCandidateSearch() {
      this.inputKeyword = ''
      if (!this.appliedKeyword) return
      this.appliedKeyword = ''
      this.refreshCandidates()
    },

    refreshCandidateDisplayOrder() {
      this.serveSceneList = this.queryRecordList.slice()
    },

    regionFilterChange(regionId) {
      if ((regionId || '') === this.selectedRegionId) return
      this.selectedRegionId = regionId || ''
      this.refreshCandidates()
    },

    configReturnBtnHandle() {
      if (this.savingCandidates || this.loadingCandidates || !this.candidateContentReady) return
      this.savingCandidates = true
      let tempSceneList = []
      let tempSceneList1 = []

      for (let i = 0; i < this.allCandidateList.length; i++) {
        if (this.allCandidateList[i].followState === 1) {
          let Scene = {}
          Scene.followOrder = this.allCandidateList[i].followOrder
          Scene.sceneId = this.allCandidateList[i].sceneId
          tempSceneList.push(Scene)
        }
      }

      tempSceneList.sort(function(a, b) {
        return a.followOrder - b.followOrder
      })
      console.log(tempSceneList)

      for (let i = 0; i < tempSceneList.length; i++) {
        tempSceneList1.push(tempSceneList[i].sceneId)
      }

      console.log(tempSceneList1)
      request({
        method: 'post',
        url: '/userScene/saveFollowStateScene',
        data: {
          token: this.$store.state.token,
          sceneList: tempSceneList1
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            showTipsToast(this, 3, res.data.message, true, 3000)
            return
          } else {
            if (!this._isDestroyed) router1.go(-1)
          }
        })
        .catch(error => {
          showTipsToast(this, 3, error.message || '保存失败，请重试')
        })
        .finally(() => {
          this.savingCandidates = false
        })
    },

    followOrderCompuder(val) {
      if (this.savingCandidates) return
      this.selectionDirty = true
      console.log('点击了取消收藏')
      console.log(val)
      changefollowOrder(this.allCandidateList, val)
      this.$nextTick(() => this.refreshCandidateDisplayOrder())
    },

    followOrderCompuInc(val) {
      if (this.savingCandidates) return
      this.selectionDirty = true
      console.log('点击了添加收藏')
      console.log(val)
      changefollowOrderInc(this.allCandidateList, val)
      this.$nextTick(() => this.refreshCandidateDisplayOrder())
    },

    showFlexComputer() {
      this.$nextTick(() => {
        if (this._isDestroyed || this.candidateAutoFillBlocked || this.loadingCandidates || this.savingCandidates) return
        const el = this.$refs.content
        if (el && el.clientHeight > 0 && el.scrollHeight <= el.clientHeight + 1)
          this.loadMoreCandidates()
      })
    },

    onScroll() {
      const el = this.$refs.content
      if (el.scrollHeight - el.scrollTop - el.clientHeight < 500) this.loadMoreCandidates()
    }
  },

  beforeMount() {},

  name: 'ModernFollowscene',
  components: {
    SceneItemView,
    CandidateToolbar
  },

  created() {
    ensureRegionNavigationScope(this)
    requestNextRegionNavigationPage(this, {
      reset: true
    }).catch(e => this.$showTipsToast(3, e.message || '获取区域失败'))
    this.refreshCandidates()
  },

  mounted() { window.addEventListener('resize', this.showFlexComputer) },

  beforeDestroy() {
    window.removeEventListener('resize', this.showFlexComputer)
    this.candidateRequestGeneration++
    this.pendingCandidateRefresh = false
  }
}
</script>
<style scoped>
.candidate-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin: auto;
}
.candidate-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  gap: 10px;
}
.candidate-heading h2 {
  font-size: 18px;
}
.candidate-content {
  overflow: auto;
  min-height: 0;
  flex: 1;
  padding: 12px 5px 80px;
}
</style>
